export const intervalToSeconds = (interval) => {
  const value = Number.parseInt(interval, 10);

  if (interval.endsWith("s")) {
    return value;
  }

  if (interval.endsWith("m")) {
    return value * 60;
  }

  if (interval.endsWith("h")) {
    return value * 60 * 60;
  }

  if (interval.endsWith("d")) {
    return value * 60 * 60 * 24;
  }

  return 60;
};

export const toChartTime = (timestamp) => Math.floor(timestamp / 1000);

export const calculateRSI = (candles, period = 14) => {
  if (!candles || candles.length <= period) {
    return 50;
  }

  const closes = candles.map((candle) => Number(candle.close));
  let gains = 0;
  let losses = 0;

  for (let index = 1; index <= period; index += 1) {
    const delta = closes[index] - closes[index - 1];
    if (delta >= 0) {
      gains += delta;
    } else {
      losses += Math.abs(delta);
    }
  }

  let averageGain = gains / period;
  let averageLoss = losses / period;

  for (let index = period + 1; index < closes.length; index += 1) {
    const delta = closes[index] - closes[index - 1];
    const gain = delta > 0 ? delta : 0;
    const loss = delta < 0 ? Math.abs(delta) : 0;

    averageGain = (averageGain * (period - 1) + gain) / period;
    averageLoss = (averageLoss * (period - 1) + loss) / period;
  }

  if (averageLoss === 0) {
    return 100;
  }

  const relativeStrength = averageGain / averageLoss;
  return Number((100 - 100 / (1 + relativeStrength)).toFixed(2));
};

export const formatCountdown = (secondsRemaining) => {
  const safeSeconds = Math.max(0, secondsRemaining);
  const hours = String(Math.floor(safeSeconds / 3600)).padStart(2, "0");
  const minutes = String(Math.floor((safeSeconds % 3600) / 60)).padStart(2, "0");
  const seconds = String(safeSeconds % 60).padStart(2, "0");
  return `${hours}:${minutes}:${seconds}`;
};
